(function () {
    angular.module('app')
        .component('labeledList', {
            bindings: {
                space: '<?'
            },
            controller: labeledListController
        });

    labeledListController.$inject = ['$scope', '$element', '$filter'];
    function labeledListController($scope, $element, filter) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.currentPadding = 0;
            ctrl.items = [];
            ctrl.$addedIds = [];
        }

        ctrl.updatePadding = function (item, remove) {
            if (ctrl.$addedIds.indexOf(item.id) === -1) {
                ctrl.items.push(item);
                ctrl.$addedIds.push(item.id);
            }
            else {
                var index = -1;
                for (var i = 0; i < ctrl.items.length; i++) {
                    if (item.id === ctrl.items[i].id) {
                        index = i;
                        break;
                    }
                }
                if (remove) {
                    if (index > -1) {
                        ctrl.addedIds.slice(addedIndex, 1);
                    }
                    var addedIndex = ctrl.$addedIds.indexOf(item.id);
                    if (addedIndex > -1) {
                        ctrl.addedIds.slice(addedIndex, 1);
                    }
                }
                else if (index > -1) {
                    ctrl.items[index] = item;
                }
            }
            if (item.width > ctrl.currentPadding) {
                ctrl.currentPadding = item.width;
            }
            else if (item.width < ctrl.currentPadding) {
                var padding = 0;
                for (var i = 0; i < ctrl.items.length; i++) {
                    var entry = ctrl.items[i];
                    if (padding < entry.width) {
                        padding = entry.width;
                    }
                }
                ctrl.currentPadding = padding;
            }
            for (var i = 0; i < ctrl.items.length; i++) {
                ctrl.items[i].element.css('padding-left', ctrl.currentPadding + (ctrl.space || 16))
            }
        }
    }
})();